import { useMemo } from "react";

import { UserPermissions } from "@/features/users/hooks/types";
import { OrganizationRoles, Roles } from "@/shared/utils/constants";
import { BaseUserResponse, FullUserResponse } from "@/redux/users/types";
import { hasOrganizationRole } from "@/redux/users/typeGuards";

export const useUserPermissions = (
  user: BaseUserResponse | FullUserResponse | null | undefined,
  currentUser: FullUserResponse | null | undefined,
): UserPermissions => {
  return useMemo(() => {
    if (!currentUser || !user) {
      return {
        canEdit: false,
        canViewOverviewTab: true,
        canViewEvidenceTab: false,
        canViewDiscussionsTab: false,
        canViewCommentsTab: false,
        canViewProfileFormsTab: true,
        canImpersonate: false,
        canCopyResetPasswordLink: false,
      };
    }

    const isGuest = hasOrganizationRole(user)
      ? user.organizationRole === OrganizationRoles.GUEST.value
      : false;
    const isCurrentUserGuest =
      currentUser.organizationRole === OrganizationRoles.GUEST.value;
    const isProfileOwner = currentUser.id === user.id;
    const isCurrentUserAppAdmin = currentUser.role === Roles.ADMIN.value;
    const isAppAdmin = currentUser.role === Roles.ADMIN.value;

    return {
      canEdit: isProfileOwner || isCurrentUserAppAdmin,
      canViewOverviewTab: true,
      canViewEvidenceTab: !isCurrentUserGuest || isProfileOwner,
      canViewDiscussionsTab: !(isGuest || isCurrentUserGuest),
      canViewCommentsTab: !(isGuest || isCurrentUserGuest),
      canViewProfileFormsTab: true,
      canImpersonate: isAppAdmin,
      canCopyResetPasswordLink: isAppAdmin,
    };
  }, [user, currentUser]);
};
